import { DepreciatedRecordRow } from "../../types";

export function totalCostOfRecords(records: DepreciatedRecordRow[]): number {
  return records.reduce(
    (acc, item) => {
      if (item.kind === 'header') return acc
      if (item.is_removed) return acc
      return acc + item.total_cost
    },
    0
  )
}

export function totalDepreciatedCostOfRecords(records: DepreciatedRecordRow[]): number {
  return records.reduce(
    (acc, item) => {
      if (item.kind === 'header') return acc
      if (item.is_removed) return acc
      return acc + item.depreciated_cost
    },
    0
  )
}

export function recordsHasNullDepreciatedCost(records: DepreciatedRecordRow[]): boolean {
  return records.some(item => {
    if (item.kind === 'header') return false
    return item.depreciated_cost === null
  })
}